import { useStateValue } from 'providers'
import { refreshAccessToken } from 'actions/api'
import React, { useCallback, useState } from 'react'

const API_URL = process.env.API_URL

export const useFileQuery = ({
  url,
  headers = {}
} = {}) => {
  const [
    {
      session: { token, refreshToken }
    },
    dispatch
  ] = useStateValue()
  const [uri, setUrl] = useState(url)
  const [data, setResponseData] = useState(null)
  const [isFetching, setFetching] = useState(false)
  const [error, setError] = useState(null)

  const post = useCallback(
    async (data, postUrl) => {
      try {
        setFetching(true)
        const response = await fetch(`${API_URL}${postUrl || uri}`, {
          method: 'POST',
          body: data,
          headers: {
            Authorization: `JWT ${token}`
          }
        })
        if (response.status === 401 && refreshToken) {
          const refreshed = await refreshAccessToken(refreshToken)
          if (refreshed) {
            dispatch({ type: 'LOGIN', data: { token: refreshed.token, refreshToken: refreshed.refreshToken } })
            const retryResponse = await fetch(`${API_URL}${postUrl || uri}`, {
              method: 'POST',
              body: data,
              headers: { Authorization: `JWT ${refreshed.token}` }
            })
            const json = await retryResponse.json()
            setResponseData(json)
            setFetching(false)
          } else {
            dispatch({ type: 'LOGOUT' })
            setFetching(false)
          }
          return
        }
        if (response.status < 200 || response.status > 299) {
          throw {
            name: 'Bad Response Status',
            message: `The server responded with ${response.status}: ${response.statusText}`
          }
        }
        const json = await response.json()

        setResponseData(json)
        setFetching(false)
      } catch (error) {
        setError(error)
        setFetching(false)
      }
    },
    [headers, uri]
  )

  return { data, isFetching, error, post, setUrl }
}
